// extracted by mini-css-extract-plugin
module.exports = {"component":"iconButton_component__1bfft","button":"iconButton_button__FS8x1"};